import React,{ Fragment } from "react";
import { useLocation,matchRoutes,Navigate } from "react-router";
import { routers } from "../route";
import { RouterInitData } from "./routerInitData";
import {useCommonStore} from "../store/useCommonStore";
import Config from "../config"

export const RouterAuth = ({ children }) => {
    // const user = useStore(s=>s.common.user);

    const user = useCommonStore((state) => state.user);
    //console.log('user in routerAuth', user);

    const location = useLocation();
    // 匹配当前层级路由树
    const mathchs = matchRoutes(routers, location)
    // 建议打个断点这里调一下，matchs是返回的层级路由
    // 第一个元素为根路由 最后一个元素为当前路由
    // 所以我们从前往后匹配
    const isNeedLogin = mathchs?.some((item) => {
      const route = item.route
        // 没有配置字段的直接返回
      if (!route.meta) return false
      // 返回是否需要登录
      return route.meta.auth
    })
  
    if (isNeedLogin && user==null) {
      console.log('需要登录')
    //   window.location.href = 'https://www.baidu.com';
    //   return;
      // 跳转到登录  state保存源路由
      return <Navigate to={Config.RoutePrefix+'/login'} state={{ from: location.pathname }} replace />
    }

    if(isNeedLogin){
        //需要初始化数据
        return <RouterInitData>{children}</RouterInitData>;
    }
  
    // return children as React.ReactElement
    return <Fragment>{children}</Fragment>
  }